export default __webpack_public_path__ + "static/media/oh-yeah-duh.38337247.gif";